import { PropsOf } from '@emotion/react'
import {
  Box,
  Card,
  CardHeader,
  useTheme,
  Link,
  Typography,
  CardActionArea,
  CardMedia,
  CardContent,
} from '@mui/material'
import { IntegrationGroup } from '@sendhub/integrations/api-client-typescript-axios'
import { useNavigate, Link as RouterLink } from 'react-router-dom'

export function IntegrationGroupImage({ src }: { src: string }) {
  return (
    <Box
      sx={{
        width: 60,
        height: 60,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <img src={src} style={{ width: '100%', height: 'fit-content' }} />
    </Box>
  )
}

/* eslint-disable-next-line */
export interface IntegrationGroupCardProps extends PropsOf<typeof Card> {
  imageUrl: string
  title: string
  viaZapier?: boolean
  cardHeaderProps?: PropsOf<typeof CardHeader>
}

export function IntegrationGroupCardLinked({
  imageUrl,
  title,
  link,
  viaZapier,
  ...cardProps
}: IntegrationGroupCardProps & { link: string }) {
  // const navigate = useNavigate()
  const theme = useTheme()
  return (
    <Link
      to={link}
      component={RouterLink}
      style={{
        margin: theme.spacing(2),
      }}
      underline="none"
    >
      <IntegrationGroupCard
        title={title}
        imageUrl={imageUrl}
        viaZapier={viaZapier}
        {...cardProps}
      />
    </Link>
  )
}

export function IntegrationGroupCard({
  imageUrl,
  title,
  cardHeaderProps,
  viaZapier,
  ...cardProps
}: IntegrationGroupCardProps) {
  return (
    <Card
      {...cardProps}
      sx={{
        width: 400,
        minWidth: 'fit-content',
        ...(cardProps?.sx || {}),
      }}
    >
      <CardHeader
        avatar={<IntegrationGroupImage src={imageUrl} />}
        title={
          <Box
            sx={{
              marginBottom: viaZapier ? 2 : 3,
              // backgroundColor: 'blue',
              // height: '100%',
            }}
          >
            <Typography>{title}</Typography>
          </Box>
        }
        subheader={
          viaZapier ? (
            <Box
              sx={{
                // alignSelf: 'flex-end',
                // backgroundColor: 'lightblue',
                // height: '100%',
                // marginTop: 2,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* <img
                style={{ height: '1rem' }}
                src="https://cdn.zapier.com/zapier/images/favicon.ico"
              /> */}
              <Typography sx={{ marginRight: 1 }}>via</Typography>
              <svg
                // width="105"
                height="1rem"
                data-testid="ZapierLogo"
                viewBox="0 0 244 66"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ filter: 'opacity(60%)' }}
              >
                <path
                  d="M57.1877 45.2253L57.1534 45.1166L78.809 25.2914V15.7391H44.0663V25.2914H64.8181L64.8524 25.3829L43.4084 45.2253V54.7775H79.1579V45.2253H57.1877Z"
                  fill="#201515"
                ></path>
                <path
                  d="M100.487 14.8297C96.4797 14.8297 93.2136 15.434 90.6892 16.6429C88.3376 17.6963 86.3568 19.4321 85.0036 21.6249C83.7091 23.8321 82.8962 26.2883 82.6184 28.832L93.1602 30.3135C93.5415 28.0674 94.3042 26.4754 95.4482 25.5373C96.7486 24.5562 98.3511 24.0605 99.9783 24.136C102.118 24.136 103.67 24.7079 104.634 25.8519C105.59 26.9959 106.076 28.5803 106.076 30.6681V31.7091H95.9401C90.7807 31.7091 87.0742 32.8531 84.8206 35.1411C82.5669 37.429 81.442 40.4492 81.4458 44.2014C81.4458 48.0452 82.5707 50.9052 84.8206 52.7813C87.0704 54.6574 89.8999 55.5897 93.3089 55.5783C97.5379 55.5783 100.791 54.1235 103.067 51.214C104.412 49.426 105.372 47.3793 105.887 45.2024H106.27L107.723 54.7546H117.275V30.5651C117.275 25.5659 115.958 21.6936 113.323 18.948C110.688 16.2024 106.409 14.8297 100.487 14.8297ZM103.828 44.6475C102.312 45.9116 100.327 46.5408 97.8562 46.5408C95.8199 46.5408 94.4052 46.1843 93.6121 45.4712C93.2256 45.1338 92.9182 44.7155 92.7116 44.246C92.505 43.7764 92.4043 43.2671 92.4166 42.7543C92.3941 42.2706 92.4702 41.7874 92.6403 41.3341C92.8104 40.8808 93.071 40.4668 93.4062 40.1174C93.7687 39.7774 94.1964 39.5145 94.6633 39.3444C95.1303 39.1743 95.6269 39.1006 96.1231 39.1278H106.093V39.7856C106.113 40.7154 105.919 41.6374 105.527 42.4804C105.134 43.3234 104.553 44.0649 103.828 44.6475Z"
                  fill="#201515"
                ></path>
                <path
                  d="M175.035 15.7391H163.75V54.7833H175.035V15.7391Z"
                  fill="#201515"
                ></path>
                <path
                  d="M241.666 15.7391C238.478 15.7391 235.965 16.864 234.127 19.1139C232.808 20.7307 231.805 23.1197 231.119 26.2809H230.787L229.311 15.7391H219.673V54.7775H230.959V34.7578C230.959 32.2335 231.55 30.2982 232.732 28.9521C233.914 27.606 236.095 26.933 239.275 26.933H243.559V15.7391H241.666Z"
                  fill="#201515"
                ></path>
                <path
                  d="M208.473 17.0147C205.839 15.4474 202.515 14.6657 198.504 14.6695C192.189 14.6695 187.247 16.4675 183.678 20.0634C180.108 23.6593 178.324 28.6166 178.324 34.9352C178.233 38.7553 179.067 42.5407 180.755 45.9689C182.3 49.0238 184.706 51.5592 187.676 53.2618C190.665 54.9892 194.221 55.8548 198.344 55.8586C201.909 55.8586 204.887 55.3095 207.278 54.2113C209.526 53.225 211.483 51.6791 212.964 49.7211C214.373 47.7991 215.42 45.6359 216.052 43.3377L206.329 40.615C205.919 42.1094 205.131 43.4728 204.041 44.5732C202.942 45.6714 201.102 46.2206 198.521 46.2206C195.451 46.2206 193.163 45.3416 191.657 43.5837C190.564 42.3139 189.878 40.5006 189.575 38.1498H216.201C216.31 37.0515 216.367 36.1306 216.367 35.387V32.9561C216.431 29.6903 215.757 26.4522 214.394 23.4839C213.118 20.7799 211.054 18.5248 208.473 17.0147ZM198.178 23.9758C202.754 23.9758 205.348 26.2275 205.962 30.731H189.775C190.032 29.2284 190.655 27.8121 191.588 26.607C193.072 24.8491 195.268 23.972 198.178 23.9758Z"
                  fill="#201515"
                ></path>
                <path
                  d="M169.515 0.00366253C168.666 -0.0252113 167.82 0.116874 167.027 0.421484C166.234 0.726094 165.511 1.187 164.899 1.77682C164.297 2.3723 163.824 3.08658 163.512 3.87431C163.2 4.66204 163.055 5.50601 163.086 6.35275C163.056 7.20497 163.201 8.05433 163.514 8.84781C163.826 9.64129 164.299 10.3619 164.902 10.9646C165.505 11.5673 166.226 12.0392 167.02 12.3509C167.814 12.6626 168.663 12.8074 169.515 12.7762C170.362 12.8082 171.206 12.6635 171.994 12.3514C172.782 12.0392 173.496 11.5664 174.091 10.963C174.682 10.3534 175.142 9.63077 175.446 8.83849C175.75 8.04621 175.89 7.20067 175.859 6.35275C175.898 5.50985 175.761 4.66806 175.456 3.88115C175.151 3.09424 174.686 2.37951 174.09 1.78258C173.493 1.18565 172.779 0.719644 171.992 0.414327C171.206 0.109011 170.364 -0.0288946 169.521 0.00938803L169.515 0.00366253Z"
                  fill="#201515"
                ></path>
                <path
                  d="M146.201 14.6695C142.357 14.6695 139.268 15.8764 136.935 18.2902C135.207 20.0786 133.939 22.7479 133.131 26.2981H132.771L131.295 15.7563H121.657V66H132.942V45.3054H133.354C133.698 46.6852 134.181 48.0267 134.795 49.3093C135.75 51.3986 137.316 53.1496 139.286 54.3314C141.328 55.446 143.629 56.0005 145.955 55.9387C150.68 55.9387 154.277 54.0988 156.748 50.419C159.219 46.7392 160.455 41.6046 160.455 35.0153C160.455 28.6509 159.259 23.6689 156.869 20.0691C154.478 16.4694 150.922 14.6695 146.201 14.6695ZM147.345 42.9602C146.029 44.8668 143.97 45.8201 141.167 45.8201C140.012 45.8735 138.86 45.6507 137.808 45.1703C136.755 44.6898 135.832 43.9656 135.116 43.0574C133.655 41.2233 132.927 38.7122 132.931 35.5243V34.7807C132.931 31.5432 133.659 29.0646 135.116 27.3448C136.572 25.625 138.59 24.7747 141.167 24.7937C144.02 24.7937 146.092 25.6994 147.385 27.5107C148.678 29.322 149.324 31.8483 149.324 35.0896C149.332 38.4414 148.676 41.065 147.356 42.9602H147.345Z"
                  fill="#201515"
                ></path>
                <path
                  d="M39.0441 45.2253H0V54.789H39.0441V45.2253Z"
                  fill="#FF4F00"
                ></path>
              </svg>
            </Box>
          ) : undefined
        }
        {...(cardHeaderProps || {})}
      />
      {/* {viaZapier && (
        <CardContent>
          <Typography>via Zapier</Typography>
        </CardContent>
      )} */}
    </Card>
  )
}

export default IntegrationGroupCard
